import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import SupplierForm from '../../purchaseTab/supplier/supplierForm';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './cards/invoiceInfo';
import InvoiceAccount from './cards/invoiceAccount';
import InvoiceJv from '../../components/journalVoucher/invoiceJv';
import LoadExpenseJv from './functions/loadExpenseJv';
import InvoiceCart from './cards/invoiceCart';

const PaymentForm = (props) => {

    const { api, userData, settingData, secondaryCurrency, rateFromToCurrency, rateToMainCurrency, companyId, sessionId, defaultCurrency,
        productData, refData, branchData, projectData, yearId, currencyData, mainCurrency, formLanguages } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, isDebit, idRow } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [cart, setCart] = useState([]);

    const cartItem = {
        accountId: '',
        index: 0,

        netPrice: 0,
        details: '',

        vatAmount: 0,
        totalPrice: 0,

        vatPercentage: 0,
        vatAmount: 0,
    };

    const [journalVoucher, setJournalVoucher] = useState({});
    const [transactions, setTransactions] = useState([])
    const [showAddAccountModal, setShowAddAccountModal] = useState(false);

    const today = new Date().toISOString().split('T')[0];
    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);


    const vatAmount = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.vatAmount), 0);
    const netPrice = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.netPrice), 0);
    const totalPrice = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.totalPrice), 0);

    const mainvatAmount = rateToMainCurrency(selectedCurrency, vatAmount);
    const secondaryvatAmount = rateFromToCurrency(selectedCurrency, secondaryCurrency, vatAmount);

    const mainTotalPrice = rateToMainCurrency(selectedCurrency, totalPrice);
    const secondaryTotalPrice = rateFromToCurrency(selectedCurrency, secondaryCurrency, totalPrice);

    const mainNetPrice = rateToMainCurrency(selectedCurrency, netPrice);
    const secondaryNetPrice = rateFromToCurrency(selectedCurrency, secondaryCurrency, netPrice);



    const openAddAccountModal = (e) => {
        setShowAddAccountModal(!showAddAccountModal);
    }


    // idRow Change
    useEffect(() => {

        if (!isLoading) {

            setTransactions(idRow?.transactions || [])
            setCart(idRow?.cart || [cartItem])

            setJournalVoucher(
                {
                    createdBy: createdBy,
                    sessionId: sessionId,
                    companyId: companyId,
                    yearId: yearId,
                    secondaryAccountId: idRow?.secondaryAccountId || null,
                    accountId: idRow?.accountId || null,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: 'ExpenseInvoice',
                    totalDebit: idRow?.totalDebit || 0,
                    totalCredit: idRow?.totalCredit || 0,
                    secondaryTotalDebit: idRow?.secondaryTotalDebit || 0,
                    secondaryTotalCredit: idRow?.secondaryTotalCredit || 0,
                    details: idRow?.details || '',
                    paymentType: idRow?.paymentType || 'cash',
                    downPayment: idRow?.downPayment || 0,
                    isDebit: idRow?.isDebit || isDebit,
                    discountType: idRow?.discountType || 'percentage',
                    discountPercentage: idRow?.discountPercentage || 0,
                    discountAmount: idRow?.discountAmount || 0,
                    currencyId: idRow?.currencyId || defaultCurrency?.id,
                    rate: idRow?.rate || defaultCurrency?.rate,

                    projectId: idRow?.projectId || null,
                    branchId: idRow?.branchId || userRole?.branchId,
                }
            )
        }
    }, [isLoading, idRow, toggleModal]);


    // change totalDebit and totalCredit
    useEffect(() => {

        setJournalVoucher((prev) => ({
            ...prev,
            totalDebit: mainTotalPrice,
            totalCredit: mainTotalPrice,
            secondaryTotalCredit: secondaryTotalPrice,
            secondaryTotalDebit: secondaryTotalPrice,
        }));

    }, [totalPrice]);

    useEffect(() => {
        if (showModal) {
            fetchData();
        } else {
            setIsLoading(true)
        }
    }, [showModal]);


    const fetchData = async () => {
        try {
            const dataArray = ['auxAccount', 'currency', 'setting', 'journalVoucher', 'project', 'branch']
            await refData(dataArray, companyId);
            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        for (const item of cart) {
            item.accountId = journalVoucher.secondaryAccountId;
        }

        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }

        if (transactions.length < 2) {
            toast.error('you need at least 2 transactions')
            return;
        }


        setLoadingEffect(true);


        const data = {
            userId: userData.id,
            sessionId,
            jvId: idRow?.id,
            transactions,
            journalVoucher,
            cart,
        }

        const operation = idRow ? 'edit' : 'add '
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('form');
        form.reset();
        setTransactions([]);
        refreshTable();
    }



    return (
        <>
            <Modal show={showModal} onHide={toggleModal} size={'xl'} backdrop="static">

                <Modal.Header style={{ background: "#23576a" }} closeButton>
                    <Modal.Title style={{ color: "white" }}>{idRow ? formLanguages.Edit : formLanguages.Add}{formLanguages.ExpenseInvoice}</Modal.Title>
                </Modal.Header>


                {isLoading &&
                    <div style={{ height: '20vh' }}>
                        <Loader />
                    </div>
                }


                {!isLoading &&
                    <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
                        <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>


                            <Row className="mb-4">
                                <Col>
                                    <Card title={formLanguages.Account} bordered={false}>
                                        <InvoiceAccount
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                            openAddAccountModal={openAddAccountModal}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>

                                    <Card title={formLanguages.Details} bordered={false}>
                                        <InvoiceInfo
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col>

                                    <Card title={formLanguages.Details} bordered={false}>
                                        <InvoiceCart
                                            mainvatAmount={mainvatAmount}
                                            secondaryvatAmount={secondaryvatAmount}
                                            mainNetPrice={mainNetPrice}
                                            secondaryNetPrice={secondaryNetPrice}
                                            mainTotalPrice={mainTotalPrice}
                                            secondaryTotalPrice={secondaryTotalPrice}
                                            cart={cart}
                                            setCart={setCart}
                                            cartItem={cartItem}
                                            validated={validated}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                            <Row className="mb-4">
                                <Col>
                                    <Card title={formLanguages.JournalVoucher} bordered={false}>
                                        <InvoiceJv
                                            transactions={transactions}
                                        />
                                    </Card>
                                </Col>
                            </Row>



                        </Modal.Body>


                        <Modal.Footer>
                            <Button type="primary" loading={loadingEffect} htmlType="submit"
                                onClick={() => setValidated(true)}
                                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
                        </Modal.Footer>
                    </Form>
                }


            </Modal >

            <LoadExpenseJv
                setTransactions={setTransactions}
                journalVoucher={journalVoucher}
                selectedCurrency={selectedCurrency}
                vatAmount={vatAmount}
                netPrice={netPrice}
                totalPrice={totalPrice}
                cart={cart}
            />
        </>
    )
}


export default PaymentForm;